import { l10nEnService } from '@uplift/services';
import { AssessmentKeys } from '@uplift/types';

export const mapAssessmentScoreToDescription = (assessment: AssessmentKeys, l10n: typeof l10nEnService) => {
  const scores = l10n.clientProfile.assessments.scores[assessment]?.scoreDescriptions;

  switch (assessment) {
    case 'phq9':
      return (score: number) => {
        if (score >= 0 && score <= 4) {
          return scores.not;
        }

        if (score >= 5 && score <= 9) {
          return scores.mildly;
        }

        if (score >= 10 && score <= 14) {
          return scores.moderately;
        }

        if (score >= 15 && score <= 19) {
          return scores.moderatelyToSeverely;
        }

        if (score >= 20 && score <= 27) {
          return scores.severely;
        }

        return 'Invalid score';
      };
    case 'gad7':
      return (score: number) => {
        if (score >= 0 && score <= 4) {
          return scores.not;
        }

        if (score >= 5 && score <= 9) {
          return scores.mildly;
        }

        if (score >= 10 && score <= 14) {
          return scores.moderately;
        }

        if (score >= 15 && score <= 21) {
          return scores.severely;
        }
      };
    default:
      return (_score: number) => null;
  }
};

export const calculateAssessmentPercentChange = (current: number, previous: number) => {
  if (current === 0 && previous === 0) {
    return 0;
  }

  if (previous === 0) {
    return current * 100;
  }

  return Math.round(((current - previous) / previous) * 100);
};
